<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Sectors/elements/Title.vue'

export default {
  name: 'SectorForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
